<template lang="pug">
  spreadsheet(:opts='opts')
</template>

<script>
export default {
  data() {
    return {
      opts: {
        tableName: 'training',
        displayName: '培训系统',
        columns: [
          {
            label: '名称',
          },
          {
            label: '关键字',
          },
          {
            label: '文件路径',
          },
          {
            label: '权限',
            type: 'select',
            width: 40,
            options: [1, 2, 3, 4, 5],
          },
          {
            label: '排序',
            width: 40,
          },
          {
            label: '点击量',
            type: 'readonly',
            width: 60,
          },
        ],
        defaultItem: {
          permissions: {
            所有人: '读取',
          },
          点击量: 0,
        },
        maxItem: 1000,
        showPagination: true,
        expandable: true,
        creatable: true,
        trackable: true,
      },
    }
  },
  created: function() {
    return this.checkRole()
  },
  methods: {
    checkRole: function() {
      let ref
      if (!(app.user.角色 && app.user.角色.includes('管理员'))) {
        return router.push('/')
      }
    },
  },
}
</script>
